import { createSharedComposable, useMediaQuery } from "@vueuse/core"

export const useMedia = createSharedComposable(() => {
    const isPhone = useMediaQuery("(max-width: 640px)")
    const isTablet = useMediaQuery("(min-width: 640px) and (max-width: 768px)")
    const isDesktop = useMediaQuery("(min-width: 768px)")

    return {
        isPhone,
        isTablet,
        isDesktop
    }
})